import React, { useState, useEffect } from 'react';
import './FeedbackPossibleLanes.scss';
import { inject, observer } from 'mobx-react';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';
import { arrayMoveImmutable as arrayMove } from 'array-move';
import SortableTextInput from 'components/SortableTextInput/SortableTextInput';
import { ReactComponent as DragIcon } from '../../assets/icons/dragicon.svg';
import { runInAction } from 'mobx';

interface FeedbackPossibleLanesProps {
  possibleLanes: any[];
  onChange: (possibleLanes: any[]) => void;
}

const FeedbackPossibleLanes = ({
  possibleLanes,
  onChange,
}: FeedbackPossibleLanesProps) => {
  const possibleLanesDeep = JSON.parse(JSON.stringify(possibleLanes));
  const [editableColumns, setEditableColumns] = useState(
    possibleLanesDeep.slice(1, possibleLanesDeep.length - 1),
  );

  useEffect(() => {
    onChange([
      possibleLanesDeep[0],
      ...editableColumns,
      possibleLanesDeep[possibleLanesDeep.length - 1],
    ]);
  }, [editableColumns]);

  const onSortEnd = (event) => {
    runInAction(() => {
      setEditableColumns(
        arrayMove(editableColumns, event.oldIndex, event.newIndex),
      );
    });
  };

  const editColumnItem = (input, index) => {
    runInAction(() => {
      const array = editableColumns.map((l) => ({ ...l }));
      array[index].title = input;
      setEditableColumns(array);
    });
  };

  const deleteColumn = (index) => {
    runInAction(() => {
      const array = editableColumns.map((l) => ({ ...l }));
      array.splice(index, 1);
      setEditableColumns(array);
    });
  };

  const addColumnToBoard = () => {
    runInAction(() => {
      const array = editableColumns.map((l) => ({ ...l }));
      array.push({
        title: 'New Column',
        key: Math.random().toString(36).substring(7),
      });
      setEditableColumns(array);
    });
  };

  const DragHandle = SortableHandle(() => (
    <DragIcon className="lanes-drag-icon" />
  ));

  const SortableItem = SortableElement((value) => (
    <div className="draggable-list-item">
      <DragHandle />
      <SortableTextInput
        input={value}
        onChange={editColumnItem}
        onEnter={() => {}}
      />
      <div
        className="delete-item"
        onClick={() => {
          deleteColumn(value.value.index);
        }}
      >
        <i className="fa-solid fa-trash" />
      </div>
    </div>
  ));

  const SortableList = SortableContainer(({ itemsList }) => {
    return (
      <div>
        {itemsList.map((value, index) => (
          <SortableItem
            key={value.key}
            index={index}
            value={{ title: value.title, index }}
          />
        ))}
      </div>
    );
  });

  if (!possibleLanes) {
    return null;
  }

  return (
    <>
      <div className="sortable-item-container">
        <div className="draggable-list-header mb-5">
          <div className="list-header">Columns</div>
          <div className="list-header add-column" onClick={addColumnToBoard}>
            + Add column
          </div>
        </div>
        <div className="draggable-list-item not-editable">
          <div className="spacer" />
          <div>{(possibleLanes[0] as any).title}</div>
        </div>
        <SortableList
          pressDelay={100}
          itemsList={editableColumns}
          onSortEnd={onSortEnd}
          useDragHandle
          helperClass="sortable-helper"
        />
        <div className="draggable-list-item not-editable">
          <div className="spacer" />
          <div>{(possibleLanes[possibleLanes.length - 1] as any).title}</div>
        </div>
      </div>
    </>
  );
};

export default inject('projectStore')(observer(FeedbackPossibleLanes));
